import { useTranslation } from "react-i18next";

interface MembershipPermissionsProps {
  readonly membershipId: string;
  readonly permissions: readonly string[];
}

/**
 * The role's permission strings, collapsed by default. A native `<details>`
 * gives keyboard and screen-reader behavior for free. Permission strings are
 * API identifiers (e.g. `org.members.read`), shown verbatim and not translated.
 */
export function MembershipPermissions({ membershipId, permissions }: MembershipPermissionsProps) {
  const { t } = useTranslation();
  return (
    <details data-testid={`membership-permissions-${membershipId}`} className="text-xs">
      <summary className="cursor-pointer text-muted-foreground">
        {t("users.memberships.permissions.summary", { count: permissions.length })}
      </summary>
      {permissions.length === 0 ? (
        <p className="mt-2 text-muted-foreground">{t("users.memberships.permissions.none")}</p>
      ) : (
        <ul className="mt-2 flex flex-wrap gap-1">
          {permissions.map((p) => (
            <li key={p} className="rounded bg-muted px-2 py-0.5 font-mono">
              {p}
            </li>
          ))}
        </ul>
      )}
    </details>
  );
}
